import { SpawnerBuilding } from "./SpawnerBuilding";

export class Castle extends SpawnerBuilding {
    readonly id = "castle";
    readonly displayName = "Castle";
    readonly spawns = "knight";
    readonly maxSpawns = 1;
    description() { return "Spawns knights."; }
    maxCooldown() { return 10000; }
}
